import { DEFAULT_LANGUAGE } from "@Constants";
import { API_URL } from "@Constants/API.constant";
import axios, { AxiosError, AxiosResponse } from "axios";
import secureLocalStorage from "react-secure-storage";
import * as Sentry from "@sentry/react";
import { CrmUsersViewModel } from "./Generates";

const currentLanguage = localStorage.getItem("language")
  ? JSON.parse(localStorage.getItem("language") || "") || DEFAULT_LANGUAGE.value
  : DEFAULT_LANGUAGE.value;

const Instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Accept-Language": currentLanguage,
  },
});

const onSuccess = (response: AxiosResponse) => {
  if (response.data.responseDataType === 0) {
    return Promise.reject(response.data);
  }

  return response;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onError = (error: AxiosError<any>) => {
  if (error?.response) {
    // Yanıt varsa (API'den dönen hata)
    const { status, data } = error.response;

    const user =
      typeof window !== "undefined" ? secureLocalStorage.getItem("user") : "";
    const decodedUser: CrmUsersViewModel = user
      ? JSON.parse(user as string)
      : null;

    Sentry.captureException(error, {
      extra: {
        request: {
          url: error.config?.url,
          method: error.config?.method?.toUpperCase(),
          body: error.config?.data,
        },
        response: {
          status,
          body: data,
        },
      },
      user: {
        id: decodedUser?.id ?? "",
        email: decodedUser?.email ?? "",
        username: decodedUser?.name + " " + (decodedUser?.surname ?? ""),
      },
    });
  }

  if (error.response && error.response.status === 401) {
    Sentry.flush();
    secureLocalStorage.clear();
    window.location.href = "/login";
  }

  // Hata mesajını döndürme (veya istediğin özel bir mesaj)

  if (error.response && error.response.data) {
    const { Message } = error.response.data;
    if (Message) {
      return Promise.reject(Message);
    } else {
      return Promise.reject("Bir hata oluştu.");
    }
  } else {
    return Promise.reject("Bir hata oluştu.");
  }
};

Instance.interceptors.response.use(onSuccess, onError);

Instance.interceptors.request.use(
  (config) => {
    const user =
      typeof window !== "undefined" ? secureLocalStorage.getItem("user") : "";
    const decodedUser = user ? JSON.parse(user as string) : null;

    if (!decodedUser && !config.url?.includes("/api/crmusers/login")) {
      const cancelTokenSource = axios.CancelToken.source();
      config.cancelToken = cancelTokenSource.token;
      cancelTokenSource.cancel("No access token available. Request canceled.");
      window.location.replace("/");

      return Promise.reject("Oturum Sonlandırıldı");
    }

    config.headers["AccessToken"] =
      config.headers["AccessToken"] || decodedUser?.accessToken;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default Instance;
